export function getScoreColor(score: number | null): string {
  if (score === null) return 'text-foreground';
  if (score >= 85) return 'text-green-700 dark:text-green-400';
  if (score >= 70) return 'text-yellow-700 dark:text-yellow-400';
  if (score >= 50) return 'text-orange-700 dark:text-orange-400';
  return 'text-red-700 dark:text-red-400';
}

interface ScoreDisplayProps {
  score: number | null;
  size?: 'sm' | 'md' | 'lg';
}

const sizeMap = {
  sm: { score: 'text-xl', suffix: 'text-xs', fallback: 'text-xl font-bold' },
  md: { score: 'text-2xl', suffix: 'text-xs', fallback: 'text-2xl font-bold' },
  lg: { score: 'text-3xl', suffix: 'text-sm', fallback: 'text-2xl font-bold leading-none tabular-nums' },
};

export function ScoreDisplay({ score, size = 'md' }: ScoreDisplayProps) {
  const styles = sizeMap[size];

  if (score === null || Number.isNaN(Number(score))) {
    return <span className={styles.fallback}>--</span>;
  }

  return (
    <span className="flex items-baseline gap-1">
      <span className={`${styles.score} font-bold leading-none tabular-nums ${getScoreColor(score)}`}>
        {Math.round(score)}
      </span>
      <span className={`${styles.suffix} text-muted-foreground/60`}>/100</span>
    </span>
  );
}
